import axios, { AxiosResponse } from "axios";
import AxiosService from "./Axios";
import moment from "moment";

class AlarmEventApi {

    public async getStatisticsOverview(): Promise<AxiosResponse<any>> {
        return AxiosService.get('/alarm-event/overview');
    }
    
    public async queryViews(request: QueryAlarmEventsRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post('/alarm-event/view/query', request);
    }

    public async ack(alarmEventId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post('/alarm-event/ack', {
            alarmEventId: alarmEventId
        });
    }
}


interface QueryAlarmEventsRequest {
    deviceId?: string,
    acked?: boolean,
    startTime?: number,
    endTime?: number,
    pageNo: number,
    pageSize: number,
}

export default AlarmEventApi;